'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/function-bind/index.js
// module id = cM5C
// module chunks = 0